import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StateService } from '@uirouter/core';

import { Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';

import { CmsDataDetail } from 'store/cms/models';

@Component({
    selector: 'xm-data-saver',
    styleUrls: ['./data-saver.scss'],
    templateUrl: './data-saver.html',
    standalone: false
})

export class DataSaverComponent implements OnInit, OnDestroy {
    @Input() public isStatusOn: boolean;
    @Input() public isActiveLine: boolean;
    @Input() public warningMessage: string;

    public pageData: CmsDataDetail;
    public imageOptions: MediaImageOptions;
    public inUseIcon: MediaImageOptions;
    public cmsData: CmsDataSaverState;

    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;
    private state: StateService;

    constructor(state: StateService, xmStore: XmStore) {
        Object.assign(this, { state, xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
            this.pageData = pageData;
            this.cmsData = this.isStatusOn ? this.pageData.dataSaverData.turnOff : this.pageData.dataSaverData.turnOn;

            this.imageOptions = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.dataSaverData.icon)
            };

            this.inUseIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.inUseIcon)
            };
        }));
    }

    public openDatasaverModal(): void {
        this.state.go(this.isStatusOn ? 'account.activity.details.data-saver.remove.review' : 'account.activity.details.data-saver.add.review');
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
